/**
 * Utility functions for formatting display values
 * Centralized formatters for consistent UI across the application
 */

/**
 * Formatteert een slug naar een leesbare naam.
 * "real-estate" -> "Real Estate"
 * "commercial+property" -> "Commercial Property"
 * "baby-kids" -> "Baby Kids"
 * 
 * @param {string} slug - The URL slug to format
 * @returns {string} Human-readable formatted name
 */
export const formatCategorySlug = (slug) => {
  if (!slug) return '';
  return slug
    .replace(/[-+]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Extracts a user-friendly error message from API error responses.
 * Handles Pydantic validation errors (arrays), string messages, and object messages.
 * 
 * @param {any} detail - The error detail from error.response?.data?.detail
 * @param {string} fallback - Fallback message if detail cannot be parsed
 * @returns {string} Human-readable error message
 */
export const formatApiError = (detail, fallback = 'An error occurred') => {
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(e => e.msg || e.message || JSON.stringify(e)).join(', ') || fallback;
  }
  if (typeof detail === 'object') {
    return detail.msg || detail.message || fallback;
  }
  return fallback;
};

/**
 * Future formatters can be added here:
 * - formatCurrency (ANG/USD)
 * - formatDate (locale-aware)
 * - formatPhoneNumber
 * - etc.
 */
